import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "./analytics";

function Success() {
  const navigate = useNavigate();

    useEffect(() => {
    const alreadyTracked = sessionStorage.getItem("purchase_tracked");

    const trackPurchase = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const sessionId = params.get("session_id");

        if (!sessionId) {
          console.warn("⚠️ No session_id found in URL");
          return;
        }

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/get-session?session_id=${sessionId}`
        );

        const data = await res.json();

        console.log("💰 Stripe session data:", data);

        if (!alreadyTracked && analytics) {
          logEvent(analytics, "purchase_completed", {
            value: data.amount_total / 100, // convert cents → dollars
            currency: data.currency,
            plan: data.plan
          });

          console.log("✅ purchase_completed event sent");

          sessionStorage.setItem("purchase_tracked", "true");
        }

      } catch (err) {
        console.error("❌ Tracking error:", err);
      }
    };

    trackPurchase();
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        paddingTop: "120px",
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          color: "#16a34a",
          fontSize: "2rem",
          marginBottom: "10px",
        }}
      >
        ✅ Payment Successful!
      </h1>

      <p
        style={{
          color: "#444",
          fontSize: "1.1rem",
        }}
      >
        Thank you for supporting EmployPilot. Your plan is now active.
      </p>

  <div
      style={{
        marginTop: "25px",
        backgroundColor: "#e0f2fe",
        border: "1px solid #7dd3fc",
        color: "#0f172a",
        padding: "16px",
        borderRadius: "10px",
        maxWidth: "520px",
        marginLeft: "auto",
        marginRight: "auto",
        fontSize: "15px",
        lineHeight: "1.6",
        fontWeight: "500",
      }}
    >
      📄 Your PDF resume is now unlocked.

      <br /><br />

    Please return to the dashboard and click the
    <strong> "Download PDF"</strong> button again to retrieve your completed resume.
  </div>

      <button
        onClick={() => {
          navigate("/", { replace: true }); // ✅ SPA navigation (no reload)
        }}
        style={{
          display: "inline-block",
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "#fff",
          borderRadius: "8px",
          textDecoration: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Return to Dashboard
      </button>
    </div>
  );
}

export default Success;
